import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import accountant from "../../../src/assets/signIn.svg";
import createRegCss from "../css/createregister.module.css";
import commoncss from "../css/common.module.css";
import { getCompany } from "../../WorkSpace/Components/ApiServices/apiHandler";

import CreateLeaseRegister from "../components/registers/CreateLeaseRegister";
import CreateLoanRegister from "../components/registers/CreateLoanRegister";
import CreateReceivableRegister from "../components/registers/CreateReceivableRegister";
import CreatePayableRegister from "../components/registers/CreatePayableRegister";
import CreatePurchaseRegister from "../components/registers/CreatePurchaseRegister";
import CreateSalesRegister from "../components/registers/CreateSalesRegister";
import CreateInvestmentRegister from "../components/registers/CreateInvestmentRegister";
import CreateFixedAssetsRegister from "../components/registers/CreateFixedAssetsRegister";

import Breadcrumb from "../components/Breadcrumb";
import { useHistory, useParams } from "react-router";

const CreateRegister = (props) => {
  const history = useHistory();
  const { reg } = useParams();
  const [allCompany, setAllCompany] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  
  useEffect(() => {
    GetCompany();
  }, []);

  const GetCompany = async () => {
    const res = await getCompany();
    if (res.status === 200) {
      setAllCompany(res.data.getCompany);
    }
  };

  useEffect(() => {
    const options = allCompany.map((c) => ({
      label: c.company_name,
      value: c._id,
    }));
    setCompanyOptions(options);
  }, [allCompany]);

  const breadcrumbItems = [
    {
      label: "Home",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Create Register",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `${reg}`, link: "", className: "headerLable" },
  ];

  return (
    <>
      <div className="conatiner">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.imgContainer}
        >
          <img
            src={accountant}
            alt="accountant working"
            style={{
              height: "93.7vh",
              "place-self": "center",
            }}
          ></img>
        </motion.div>
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.formContainer}
        >
          <div className={commoncss.dFlexJustifysb}>
            <Breadcrumb
              style="margin-right:auto"
              items={breadcrumbItems}
              headerActions={<></>}
            />
          </div>
          {reg === "Lease" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateLeaseRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Loan" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateLoanRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Receivable" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateReceivableRegister
                companyOptions={companyOptions}
                
              />
            </motion.div>
          )}
          {reg === "Payable" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreatePayableRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Purchase" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreatePurchaseRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Sales" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateSalesRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Investment" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateInvestmentRegister companyOptions={companyOptions} />
            </motion.div>
          )}
          {reg === "Fixed Assets" && (
            <motion.div
              initial={{ x: 400, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              <CreateFixedAssetsRegister companyOptions={companyOptions} />
            </motion.div>
          )}
        </motion.div>
      </div>
    </>
  );
};

export default CreateRegister;
